<template>
    <div class="relative s-pt-100 bg-white dark:bg-title">
        <div class="container">
            <div class="max-w-1366 mx-auto flex items-start justify-between gap-10 flex-col lg:flex-row">
                <div class="sm:max-w-[450px] sm:mx-auto lg:mx-0 lg:max-w-[345px] xl:max-w-[477px] w-full sm:text-center lg:text-left">
                    <!-- Word-mark, like the navbar: the template's logo file carried the vendor's brand. -->
                    <router-link class="cursor-pointer inline-block" to="/" :aria-label="company.name">
                        <span class="block font-semibold leading-none text-title dark:text-white text-[22px] sm:text-[26px] tracking-tight">{{ company.name }}</span>
                        <span class="mt-2 block text-[11px] uppercase tracking-[0.22em] text-primary">{{ company.shortTagline }}</span>
                    </router-link>
                    <p class="mt-4">{{ company.description }}</p>
                    <!-- router-link cannot address another site; these need real anchors.
                         The list comes from company.js so every footer agrees on which
                         networks exist. -->
                    <div class="flex items-center gap-4 mt-6 sm:justify-center lg:justify-start">
                        <a v-for="link in socialProfiles" :key="link.label" :href="link.href" target="_blank" rel="noopener" :aria-label="link.label"
                           class="w-10 h-10 rounded-full border border-[#8B9197] dark:border-white-light flex items-center justify-center group hover:border-primary duration-300 hover:border-transparent dark:hover:text-white dark:hover:border-transparent hover:bg-primary text-[#5D656E] dark:text-white-light hover:text-white">
                            <i :class="link.icon" class="text-[#5B646D] dark:text-white group-hover:text-white duration-300"></i>
                        </a>
                    </div>
                </div>

                <div class="grid grid-cols-2 gap-x-6 gap-y-10 sm:gap-10 lg:max-w-[695px] w-full sm:flex items-start justify-between footer2-inner-wrapper">
                    <div>
                        <h4 class="leading-none mb-5 md:mb-6 text-xl">Sitemap</h4>
                        <ul class="text-title dark:text-white leading-none flex flex-col gap-4">
                            <li v-for="(item, index) in footerLink1" :key="index" class="duration-100 hover:text-primary inline-block group"><router-link class="text-underline-primary" :to="item.link">{{item.name}}</router-link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 class="leading-none mb-5 md:mb-6 text-xl">Others</h4>
                        <ul class="text-title dark:text-white leading-none flex flex-col gap-4">
                            <li v-for="(item, index) in footerLink2" :key="index" class="duration-100 hover:text-primary inline-block group"><router-link class="text-underline-primary" :to="item.link">{{item.name}}</router-link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 class="leading-none mb-5 md:mb-6 text-xl">Shop</h4>
                        <ul class="text-title dark:text-white leading-none flex flex-col gap-4">
                            <li v-for="(item, index) in footerLink3" :key="index" class="duration-100 hover:text-primary inline-block group"><router-link class="text-underline-primary" :to="item.link">{{item.name}}</router-link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 class="leading-none mb-5 md:mb-6 text-xl">Customer Service</h4>
                        <ul class="text-title dark:text-white leading-none flex flex-col gap-4">
                            <li v-for="(item, index) in footerLink4" :key="index" class="duration-100 hover:text-primary inline-block group"><router-link class="text-underline-primary" :to="item.link">{{item.name}}</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="max-w-[1722px] mx-auto border-t border-bdr-clr dark:border-bdr-clr-drk py-5 md:py-7 mt-7 text-center">
                <p>© {{ year }} {{ company.name }} — {{ company.address }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { company, socialProfiles } from '@/data/company';
    import { ref } from 'vue';
    import { footerLink1,footerLink2, footerLink3,footerLink4 } from '@/data/nav-data';

    const year = ref(new Date().getFullYear());

</script>

<style>
/* The template collapses the link columns to one on small phones; two columns read better. */
@media screen and (max-width: 390px) {
    .container .footer2-inner-wrapper { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
    .container .footer2-inner-wrapper h4 { font-size: 18px; }
}
</style>
